export default __webpack_public_path__ + "static/media/catalogo-dark.500ecefb.svg";